import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import { RuntimeErrorBoundary } from "./components/providers/runtime-observability.tsx";
import { installGlobalClientObservability } from "./lib/client-observability.ts";

installGlobalClientObservability();

createRoot(document.getElementById("root")!).render(
  <RuntimeErrorBoundary scope="application.root">
    <App />
  </RuntimeErrorBoundary>,
);
